import CatalogItemClass from './includes/catalog-item.js'

class GroupPageClass {

  changeOrder(order,asc) {
      $("#catalog_order > li").removeClass("uk-active");
      let $curItem = $('#catalog_order').find('li[sort-type="'+order+'"]'+'[sort-asc="'+asc+'"]');
      $curItem.addClass("uk-active");
      $("#catalog_order_title").text($curItem.find("a").text());
      UIkit.dropdown($('#catalog_order_dropdown')[0]).hide();

      this.loading = false;
      this.allLoaded = false;
      this.curPage = 0;
      this.curOrder = order;
      this.curAsc = asc;
      
      $("#items_loader").show();
      $("#catalog_items").empty();
      $("#catalog_items").load("/catalog/items/",{
        order : order,
        asc : asc,
        category_id : curCategoryId,
        group_id : curGroupId,
      },()=>{
        $("#items_loader").hide();
        this.items = [];
        $("#catalog_items").find('.js-shop-item').each((i,itm)=>{
          this.items.push( new CatalogItemClass($(itm)) );
        });
        UIkit.scrollspyNav('.car-group-filter', {closest: 'a', scroll: true, cls:'active', offset: 0});
      });
  }
  
  initScrollGroups() {
    this.curItem = null
    $(window).on('scroll',()=>{
      this.doScroll()
    })
    this.doScroll()
  }
  
  doScroll() {
    let newItem = $('.car-group-filter').find('.car-group-filter-item.active')
    if (!this.curItem || newItem[0] !== this.curItem[0]) {
      this.curItem = newItem
      let offs = newItem.position().left
      let scrollLeft = $('.car-group-filter-container').scrollLeft()
      $('.car-group-filter-container').scrollLeft(scrollLeft+offs);
    }
  }
  
  constructor() {
    $("#catalog_order > li").each((i,$itm)=>{
      $itm = $($itm);
      var order = $itm.attr("sort-type");
      var asc = $itm.attr("sort-asc");
      $itm.find("a").click((ev)=>{
        ev.preventDefault();
        this.changeOrder(order,asc)
      });
    });
    this.initScrollGroups()
  }
}

let groupPage = null;
$(document).ready(function ($) {
  this.items = [];
  this.loading = false;
  this.allLoaded = false;
  this.curPage = 0;
  this.curOrder	 = '';
  this.curAsc = '';
  groupPage = new GroupPageClass();
});

